"use client";

import { NoRecSelected } from "@/app/(inbox)/components/PreScreenForRec/NoRecSelected";

export function InboxHome() {
  return <NoRecSelected isLoading={false} />;
}
